<template>
  <div>
    <div id='chartdiv' ref='agingStockAnalysis'></div>
  </div>
</template>
  
  <script>
  /* eslint-disable */
  import * as am4core from '@amcharts/amcharts4/core'
  import * as am4charts from '@amcharts/amcharts4/charts'
  import axios from 'axios'
  
  export default {
    data() {
      return {
        company: sessionStorage.getItem('company'),
        chart: null,
        categories : ['< 1 Day', '1 to 7 Days', '8 to 30 Days', '1 to 3 Months', '3 to 6 Months', '> 6 Months'],
        apiVar : ['under_1_day', 'day_1_7', 'day_8_30', 'month_1_3', 'month_3_6', 'month_6'],
        // data: null
      }
    },
    props: ['filterUrl'],
    mounted() {
      this.generateChart();
    },
    watch: {
      filterUrl: function () {
        this.fetchData()
      }
    },
    methods: {
      fetchData() {
        var length = this.chart.data.length
        var vm = this;
        var compiledData = [];
  
        this.$http.get('/api/h1/aging-stock/aging-stock-analysis?' + this.filterUrl)
        .then((resp) => {
          var data = resp.data.data;

          for(var i = 0; i < vm.categories.length; i++){
            compiledData.push({
              category : vm.categories[i],
              value : data[vm.apiVar[i]]
            })
          }

          vm.chart.addData(compiledData, length)
        })
        .catch((err) => {
          console.log(err)
        })
      },
      generateChart() {
        this.chart = am4core.create(this.$refs.agingStockAnalysis, am4charts.XYChart);
  
        // let title = this.chart.titles.create()
        // title.text = 'Average Service Cycle'
        // title.fontSize = 20
        // title.marginBottom = 30
        // title.fontWeight = 'Bold'
  
        var categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
        categoryAxis.dataFields.category = 'category'
        categoryAxis.renderer.grid.template.location = 0
        categoryAxis.renderer.minGridDistance = 10
  
        if (this.isMobile()) {
          categoryAxis.renderer.labels.template.horizontalCenter = 'right'
          categoryAxis.renderer.labels.template.verticalCenter = 'middle'
          categoryAxis.renderer.labels.template.rotation = 270
        }
  
        var valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())
        valueAxis.min = 0
        valueAxis.title.text = 'Number of Vehicles'
  
        // Create series
        var series = this.chart.series.push(new am4charts.ColumnSeries())
        series.dataFields.valueY = 'value'
        series.dataFields.categoryX = 'category'
        series.name = 'value'
        series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]'
        series.columns.template.fillOpacity = .8
  
        var columnTemplate = series.columns.template
        columnTemplate.strokeWidth = 2
        columnTemplate.strokeOpacity = 1
      },
    }
  }
  </script>
  
  <style scoped>
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    }
  
    #chartdiv {
      width: 100%;
      height: 500px;
    }
  </style>